module.exports = "/_next/static/images/logo-book-42fea3590550a9e2468d99130ee7f398.gif";